export default __webpack_public_path__ + "static/media/facebook-white.88714714.svg";